const Style = {
  base: "block w-[10em] h-[2em] mx-auto mb-8 outline-none",
};

export default Style;
